


export interface ISponserData{

    sponserInfo?:ITblSponser;
    sponserContacts?:ITbl_SponserContacts[];
    Products?:ITbl_Products[];
}

export interface ITblSponser
{
id?: number;
name?: string;
address?: string;
notesAndComments?: string;
createdBy?: number;
createdDate?: Date;
updatedBy?: number;
updatedDate?: Date;
isDeleted?: boolean;
sponserId?: string;
//StatusMappingId?:number;

}

export interface ITbl_SponserContacts
{
id?:number;
name?:string;
designation?:string;
countryCode?:string;
phoneNumber?:string;
email?:string;
sponserId?:number;
createdBy?:number;
createdDate?:Date;
updatedBy?:number;
updatedDate?:Date;
isDeleted?:boolean;
isSendNotification?:boolean;
localId?:number;
}   

export interface ITbl_Products
{
id?:number;
productName?:string;
longName?:string;
genericName?:string;
internalName?:string;
tradeName?:string;
statusMappingId?: number;   
sponserId?:number;
createdBy?:number;
createdDate?:Date;
updatedBy?:number;
updatedDate?:Date;
isDeleted?:boolean;
localId?:number;
}
export class SponsorProduct {
  id?: number = 0;
productName?:string;
longName?:string;
genericName?:string;
internalName?:string;
tradeName?:string;
statusMappingId?: number;  
  status?: string = "";
  createdBy?:number;
  createdDate?:Date;
  updatedBy?:number;
  updatedDate?:Date;
  isDeleted?:boolean;
  localId?:number;
  
}